import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./FilterPicker.style";
import { IPlaceFilter, PlaceFilterTable } from "../../backend/cloud/PlaceFilterTable";
import { ChangeSet, ChangeSetListener } from "../../DataStore/ChangeSet";
import { DataProvider } from "../../DataStore/DataProvider";

@customElement("ds-filter-picker")
export class FilterPicker extends BaseElement implements ChangeSetListener {
    static override styles = [styles, LightTheme];

    @state() protected _allFilters: IPlaceFilter[] = [];

    private _placeFilters = this._kernel.dataStore.getSource<PlaceFilterTable>("place-filters");

    private _raiseFilterChanged(filter: IPlaceFilter) {
        this._raiseEvent("ds-filter-changed", filter);
    }

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._placeFilters.addListener(this, []);
        await this._loadFilters();
    }

    onChangeSet(_provider: DataProvider, _changeSet: ChangeSet<any>): void {
        this._loadFilters();
    }

    private async _loadFilters() {
        this._allFilters = Array.from(await this._placeFilters.all());
    }

    override render() {
        return html` <sl-dropdown>
            <sl-button pill size="small" slot="trigger" caret>Choose filter</sl-button>
            <sl-menu>
                ${this._allFilters.map(
                    (x) =>
                        html`<sl-menu-item
                            @click=${async () => {
                                this._raiseFilterChanged(x);
                            }}
                            >${x.name}
                            <sl-icon
                                slot="prefix"
                                name=${x.table === "public-filters"
                                    ? "shield-shaded"
                                    : "person-fill"}
                            ></sl-icon>
                        </sl-menu-item>`
                )}
            </sl-menu></sl-dropdown
        >`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-filter-picker": FilterPicker;
    }
}
